<template>
  <v-card flat color="transparent" style="min-height: 50rem;" :loading="loading">
    <v-row>
      <v-col cols="12" class="d-flex justify-center ma-2">
        <v-text-field
          :label="$t('portfolio.general.searchIn', { title: $t('portfolio.WorkSample.plural') })"
          v-model="search"
          append-icon="mdi-magnify"
          outlined
          dense
          hide-details
        />
      </v-col>
    </v-row>
    <v-row  class="ma-0 pa-0">
      <v-col cols="12" v-if="workSamples.length > 0 && filteredWorkSamples.length > 0">
        <v-row>
          <v-col
            cols="12"
            v-for="(i, index) in paginated"
            :key="i.workSampleGuid"
            lg="3"
            md="4"
            sm="12"
            xs="12"
          >
            <BaseCard
              height="100%"
              :showIcons="$store.state.userData.guid === i.student.studentGuid"
              :key="i.workSampleGuid"
              :imageLink="getFirstImage(i.files)"
              :title="i.title ? i.title : '-'"
              @details="navToDetails(i)"
              @delete="deleteWorkSample(i)"
              @edit="$refs.addWorkSampleDialog.showDialogEdit(i)"
              :description="i.caseDescription"
            >
              <template slot="header-actions">
                <div class="d-flex align-center  justify-end" style="gap: 0.5rem;" >
                  <v-icon v-if="(isInRole(2) && i.flag) || isInRole(0)"
                    :title="$t('portfolio.WorkSample.fields.flagged')"
                    @click="toggleFlag(i)"
                    :color="i.flag ? 'error' : 'primary'"
                    >{{ i.flag ? "mdi-flag" : "mdi-flag-outline" }}</v-icon
                  >
                  <v-icon v-if="(isInRole(2) && i.forAttention) || isInRole(0)"
                    :title="$t('portfolio.WorkSample.fields.forAttention')"
                    @click="toggleAttention(i)"
                    :color="i.forAttention ? 'warning' : 'primary'"
                    >{{ i.forAttention ? "mdi-alert-circle" : "mdi-alert-circle-outline" }}</v-icon
                  >
                </div>
              </template>
              <template slot="content">
                <VDivider />
                  
                <div class="d-flex">
                    <div class="ma-2">
                      <TagsMini v-model="i.tags" :sourceGuid="i.workSampleGuid" sourceType="WorkSample" :showAdd="isInRole(0)" :isRemovable="isInRole(0)"   />
                    </div>
                     
                </div>
                  <v-chip class="ms-1 align-self-start"
                      label
                      color="transparent"
                      small
                      :title="i.createdDate | moment('YYYY/MM/DD - h:mm A')"
                    >
                      {{ fromNow(i.createdDate) }}
                    </v-chip>
              </template>
            </BaseCard>
          </v-col>
        </v-row>
        <div class="d-flex flex-wrap " style="gap:0.5rem"></div>
        <v-pagination
          v-model="currentPage"
          :length="totalPages"
          :total-visible="3"
          class="mx-auto my-5"
        />
      </v-col>
      <v-col cols="12" v-else-if="!loading">
        <NoData />
      </v-col>
    </v-row>


    <AddWorkSample ref="addWorkSampleDialog" @success="getWorkSamples" />
    <ConfirmActionDialogue
      :title="$t('portfolio.WorkSample.removeWorkSample')"
      :description="
        $t('portfolio.WorkSample.confirmRemoveWorkSample', { title: activeWorkSample.title })
      "
      ref="confirmActionDialog"
      @confirm="handleConfirmDeleteAction"
    />

    <v-fab-transition v-if="this.studentGuid === this.$store.state.userData.guid">
      <v-btn
        :title="$t('portfolio.WorkSample.addWorkSample')"
        color="secondary"
        fab
        large
        elevation="6"
        fixed
        bottom
        :left="$vuetify.rtl"
        :right="!$vuetify.rtl"
        class="v-btn--example"
        :class="$store.state.drawerMessage ? 'ml-16' : ''"
        :style="!$vuetify.rtl ? 'right:50px' : ''"
        @click="$refs.addWorkSampleDialog.showDialog()"
      >
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </v-fab-transition>
  </v-card>
</template>

<script>
import NoData from "@/components/noData.vue";
import ConfirmActionDialogue from "@/components/confirmActionDialog.vue";
import BaseCard from "../../../components/portfolio/baseCard.vue";
import SearchTextField from "../../../components/portfolio/searchTextfield.vue";
import AddWorkSample from "../../../components/portfolio/workSample/worksampleDialog.vue";
import LoadingData from "../../../components/loadingData.vue";
import TagsMini from "../../../components/portfolio/tagsMini.vue";

export default {
  name: "WorkSamples",
  props: {
    studentGuid: {
      required: true,
      type: String
    }
  },
  components: {
    BaseCard,
    SearchTextField,
    AddWorkSample,
    ConfirmActionDialogue,
    NoData,
    LoadingData,
    TagsMini
  },
  data() {
    return {
      loading: true,
      search: null,
      activeWorkSample: {
        title: ""
      },
      workSamples: [],
      currentPage: 1,
      itemsPerPage: 4
    };
  },
  mounted() {
    this.getWorkSamples();
  },
  methods: {
    getWorkSamples() {
      this.loading = true;
      if (this.isInRole(2)) {
        this.axios
          .get("/WorkSample/GetByStudent/" + this.studentGuid)
          .then(response => {
            this.workSamples = response.data.data;
          })
          .catch(error => {
            console.error("Error fetching work samples:", error);
          })
          .finally(() => {
            this.loading = false;
          });
      } else if (this.isInRole(0)) {
        this.axios
          .get("/WorkSample/Get")
          .then(response => {
            this.$set(this, "workSamples", response.data.data);
          })
          .catch(error => {
            console.error("Error fetching work samples:", error);
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    deleteWorkSample(workSample) {
      this.activeWorkSample = workSample;
      this.$refs.confirmActionDialog.showDialog();
    },
    handleConfirmDeleteAction() {
      this.axios
        .post(`/WorkSample/Delete`, { worksampleGuid: this.activeWorkSample.workSampleGuid })
        .then(response => {
          this.getWorkSamples();
        })
        .catch(error => {
          console.error("Error deleting work sample:", error);
        });
    },
    navToDetails(i) {
      this.$router.push({ name: "portfolio.WorkSample.details", params: { id: i.workSampleGuid } });
    },
    getFirstImage(files) {
      if (!files || !Array.isArray(files) || files.length === 0) return null;
      const imageExtensions = [".jpg", ".jpeg", ".png", ".gif", ".bmp"];
      const firstImage = files.find(file =>
        imageExtensions.some(ext => file.fileName.toLowerCase().endsWith(ext))
      );
      return firstImage ? firstImage.fileUrl : null;
    },
    toggleFlag(worksample) {
      if (this.$store.state.userData.guid != worksample.student.studentGuid) return;
      this.axios
        .post(`/WorkSample/ToggleFlag`, null, {
          params: { worksampleGuid: worksample.workSampleGuid }
        })
        .then(res => {
          worksample.flag = res.data;
        })
        .catch(error => {
          console.error("Error toggling flag:", error);
        });
    },
    toggleAttention(worksample) {
      if (this.$store.state.userData.guid != worksample.student.studentGuid) return;
      this.axios
        .post(`/WorkSample/ToggleForAttention`, null, {
          params: { worksampleGuid: worksample.workSampleGuid }
        })
        .then(res => {
          worksample.forAttention = res.data;
        })
        .catch(error => {
          console.error("Error toggling attention:", error);
        });
    },
    searchInput(search) {
      this.search = search;
      this.currentPage = 1;
    },
    fromNow(date) {
      return this.$moment(date).fromNow();
    }
  },

  watch: {
    // Add your watchers here
  },
  computed: {
    totalPages() {
      const filtered = this.filteredWorkSamples;
      return Math.ceil(filtered.length / this.itemsPerPage);
    },
    paginated() {
      const filtered = this.filteredWorkSamples;
      if (filtered.length === 0) return [];
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      if (end > filtered.length) {
        return filtered.slice(start);
      }
      if (start > filtered.length) {
        return [];
      }
      return filtered.slice(start, end);
    },
    filteredWorkSamples() {
      if (this.search) {
        const searchLower = this.search.toLowerCase();
        return this.workSamples.filter(
          i =>
            i.title.toLowerCase().includes(searchLower) ||
            i.caseDescription.toLowerCase().includes(searchLower)
        );
      }
      return this.workSamples;
    }
  }
};
</script>

<style scoped>
.work-samples {
  padding: 20px;
}

.samples-list {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}
</style>
<style scoped>
.wrapped-text {
  word-break: normal;
  /* Ensures words don't break mid-letter */
  overflow-wrap: normal;
  /* Only wraps at spaces */
  white-space: normal;
  /* Allows text to wrap */
}
</style>
